export default __webpack_public_path__ + "UNt_guide.html";